import {
  FormattedDate,
  FormattedTime,
  FormattedRelativeTime as OriginalFormattedRelativeTime,
} from "react-intl";
import Tooltip from "../Tooltip";

type OwnProps = {
  value?: $TSFixMe; // TODO: PropTypes.instanceOf(Date)
  hideTooltip?: boolean;
  updateIntervalInSeconds?: number;
  style?: string;
  customClass?: string;
  numeric?: string;
};

const defaultProps: Partial<OwnProps> = {
  value: undefined,
  hideTooltip: false,
  style: "long",
  updateIntervalInSeconds: 1,
  numeric: "auto",
};

type Props = OwnProps & typeof defaultProps;

function FormattedRelativeTime(props: Props) {
  const { value, customClass } = props;
  const { hideTooltip } = props;

  // display date if value older than 7 days
  const sevenDaysAgo = new Date(); // today!
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

  const renderDateTimeWithoutTooltip = () => {
    const spanProps = { "data-testid": "formatted-datetime" };
    if (customClass) {
      (spanProps as $TSFixMe).className = customClass;
    }
    return (
      <span {...spanProps}>
        {value.getTime() < sevenDaysAgo.getTime() ||
        value.getTime() > Date.now() ? (
          // @ts-expect-error TS(2322) FIXME: Type '{ "data-testid": string; year: "numeric"; mo... Remove this comment to see the full error message
          <FormattedDate
            {...props}
            data-testid="formatted-date"
            year="numeric"
            month="2-digit"
            day="2-digit"
          />
        ) : (
          // @ts-expect-error TS(2322) FIXME: Type '{ "data-testid": string; value: number; hide... Remove this comment to see the full error message
          <OriginalFormattedRelativeTime
            {...props}
            data-testid="formatted-time"
            value={((Date.now() - value.getTime()) / 1000) * -1}
          />
        )}
      </span>
    );
  };

  const render = () => {
    if (hideTooltip) {
      return renderDateTimeWithoutTooltip();
    }

    return (
      <Tooltip
        data-testid="tooltip"
        content={
          <>
            {/* @ts-expect-error TS(2322) FIXME: Type '{ year: "numeric"; month: "2-digit"; day: "2... Remove this comment to see the full error message */}
            <FormattedDate
              {...props}
              year="numeric"
              month="2-digit"
              day="2-digit"
            />
            <span> </span>
            {/* @ts-expect-error TS(2322) FIXME: Type '{ value?: any; hideTooltip?: boolean | undef... Remove this comment to see the full error message */}
            <FormattedTime {...props} />
          </>
        }
      >
        {renderDateTimeWithoutTooltip()}
      </Tooltip>
    );
  };

  return value ? render() : null;
}

FormattedRelativeTime.defaultProps = defaultProps;

export default FormattedRelativeTime;
